export const userService = {
    register,
};

function register(name, email, body, token) {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://orthus.entertainment-intelligence.com/api/v1';
    const url = `${API_BASE_URL}/contact_form`;

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify({ 
            email: email, 
            name: name, 
            body: body,
            'g-recaptcha-response': token
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => response.json())
        .then((contents) => {
            return contents
        })
        .catch(e => {
            return (e);
        });
}
